import React from "react";
import "./ft.scss";
const HeroFt = () => {
  return (
    <>
      <div className="main-ft-hero mb-20">
        <div className="absolute bg-1"></div>
        <div className="absolute bg-2"></div>
        <div className="absolute bg-3"></div>
        <div className="absolute bg-4"></div>
        <div className="flex main-head-ft justify-start pl-20 pt-52">
          <h1>Start your Free-trial</h1>
        </div>
      </div>
    </>
  );
};

export default HeroFt;
